<template>
    <div class="jump-cart">
        <van-nav-bar title="砸金蛋" left-arrow fixed class="jump-nav-bar" @click-left="back"/>
        <div class="jump-cart-body">
            <iframe ref="iframe" id="bdIframe" :src="egg+'?token='+token+'&url='+url+'&userId='+userId" frameborder="0"
                    scrolling="no" ></iframe>
        </div>
    </div>
</template>
<script>
    import {NavBar, Row, Col, List} from "vant";

    export default {
        name: "userhistory",
        components: {
            [NavBar.name]: NavBar,
            [Row.name]: Row,
            [Col.name]: Col,
            [List.name]: List
        },
        data() {
            return {
                token: localStorage.getItem("token"),
                url:this.$api.root,
                egg:this.$api.egg,
                userId:localStorage.getItem("userId")
            };
        }, mounted: function () {
            /**
             * iframe-宽高自适应显示
             */
            const oIframe = document.getElementById('bdIframe');
            const deviceWidth = document.documentElement.clientWidth;
            const deviceHeight = document.documentElement.clientHeight;
            oIframe.style.width = (Number(deviceWidth)) + 'px'; //数字是页面布局宽度差值
            oIframe.style.height = (Number(deviceHeight)) + 'px'; //数字是页面布局高度差
        },
        methods: {
            back() {
                history.back();
            }, goEgg() {
                location.href = 'https://www.baidu.com'
            }
        }
    };
</script>
<style lang="less">

</style>

